import classNames from 'classnames'

import { Check } from '../icon/solar-icons.js'
import { Sheet } from '../sheet/sheet.js'
import './option-sheet.scss'

export interface OptionSheetOption<T extends string> {
    value: T
    label: string
}

export interface OptionSheetProps<T extends string> {
    isOpen: boolean
    title: string
    options: OptionSheetOption<T>[]
    value: T
    onChange: (value: T) => void
    onClose: () => void
}

/** Bottom sheet with a single-choice list; the chosen row carries a check and picking closes it. */
export const OptionSheet = <T extends string>(props: OptionSheetProps<T>) => (
    <Sheet isOpen={props.isOpen} title={props.title} onClose={props.onClose}>
        <div className="option-sheet__list" role="radiogroup" aria-label={props.title}>
            {props.options.map((option) => {
                const isChecked = option.value === props.value
                return (
                    <button
                        key={option.value}
                        type="button"
                        role="radio"
                        aria-checked={isChecked}
                        // BaseModal does not move focus into the dialog: land on the current choice.
                        autoFocus={isChecked}
                        className={classNames(
                            'option-sheet__option',
                            isChecked && 'option-sheet__option--checked',
                        )}
                        onClick={() => {
                            props.onChange(option.value)
                            props.onClose()
                        }}
                    >
                        <span>{option.label}</span>
                        <span className="option-sheet__mark" aria-hidden="true">
                            {isChecked && <Check size={14} />}
                        </span>
                    </button>
                )
            })}
        </div>
    </Sheet>
)
